import { generateOffers } from "./generateOffers";
import { getLink } from "./getLink";
import { getMaritalStatus } from "./getMaritalStatus";
import { getPanId } from "./getPanId";
import { makeProposal } from "./makeProposal";
import { sendProposal } from "./sendProposal";

export const panService = {
  makeProposal,
  getMaritalStatus,
  getPanId,
  generateOffers,
  sendProposal,
  getLink,
};
